<template>
  <div ref="container" class="container">
    <div v-if="player.thumb.current && container" v-html="current"
         :style="style" :class="{'full': fullHeight, 'pp-ui-thumbnail': true }"></div>
  </div>
</template>

<script>
import { PPComponentMixin } from "../mixins";

export default {
  name: "PPThumbnail",
  mixins: [PPComponentMixin],
  props: {
    thumbWidth: {
      type: Number,
      default: 180
    },
    /**
     * If true, the thumbnail should cover the whole height of the player
     * element (width is be adjusted according to the aspect ratio).
     */
    fullHeight: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      container: null
    }
  },
  mounted () {
    this.container = this.$refs.container;
  },
  destroyed () {
    this.container = null;
  },
  computed: {
    current () {
      if(this.fullHeight) {
        if(!this.player.thumb.current) return '';
        const element = this.player.thumb.current.element();
        if (!element) return '';
        const imageWidth = Number(element.style.width.replace('px', ''));
        const imageHeight = Number(element.style.height.replace('px', ''));
        const containerWidth = this.container.offsetWidth;
        const containerHeight = this.container.offsetHeight;
        const scale = Math.min(
          containerWidth / imageWidth,
          containerHeight / imageHeight
        );
        // Delta to make the image centered horizontally, the calculation is
        // slightly confusing due to scaling.
        const deltaX = ((containerWidth / scale) - imageWidth) / 2;
        element.style['transform-origin'] = "top left";
        element.style.transform = `scale(${scale}) translateX(${deltaX}px)`;
        element.style.backgroundColor = 'transparent';
        return element.outerHTML;
      }

      const element = this.player.thumb.current.element(this.thumbWidth);
      if (!element) return '';
      return element.outerHTML;
    },
    position () {
      if (!this.container || this.fullHeight){
        return 0;
      }

      const width = this.$refs.container.offsetWidth;
      let target = width * this.player.thumb.positionRelative;
      target = Math.max(0, target - (this.thumbWidth / 2));

      const paddingRight = Number(window.getComputedStyle(
        this.$refs.container).paddingRight.replace('px', ''));
      const paddingLeft = Number(window.getComputedStyle(
        this.$refs.container).paddingLeft.replace('px', ''));
      const padding = paddingRight + paddingLeft;
      target = Math.min(width - this.thumbWidth - padding, target);
      return target;
    },
    style() {
      if (this.fullHeight) {
        return {};
      }

      return {
        transform: `translateX(${this.position}px)`
      }
    },
  }
}
</script>

<style scoped>
  .full {
    position: relative;
    height: 100%;
  }
  .container {
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
  }
</style>
